import { useState, useEffect } from 'react';
import { Currency, detectUserCurrency, getCurrencyPreference, saveCurrencyPreference } from '../config/currency';
import paykuConfig from '../config/payku';

export interface DynamicCoinPackage {
    id: string;
    name: string;
    description: string;
    vcoins: number;
    cvs: number;
    amount: number;  // Precio dinámico según moneda
    currency: Currency;
    amount_usd: number;
    amount_clp: number;
    popular?: boolean;
    recommended?: boolean;
    bestValue?: boolean;
    discount?: number;
    popularidad?: string;
    coins?: number; // Para compatibilidad con código legacy
    price?: number; // Para compatibilidad con código legacy
}

export function useCurrencyPackages() {
    const [currency, setCurrency] = useState<Currency>('CLP');
    const [isDetectingCurrency, setIsDetectingCurrency] = useState(true);
    const [packages, setPackages] = useState<DynamicCoinPackage[]>([]);

    useEffect(() => {
        const initializeCurrency = async () => {
            try {
                // 1. Verificar si hay preferencia guardada
                const savedCurrency = getCurrencyPreference();
                if (savedCurrency) {
                    setCurrency(savedCurrency);
                    setIsDetectingCurrency(false);
                    return;
                }

                // 2. Por defecto usar CLP
                setCurrency('CLP');
                saveCurrencyPreference('CLP');
                console.log(`[useCurrencyPackages] Moneda por defecto: CLP`);

                setIsDetectingCurrency(false);
            } catch (err) {
                console.error('[useCurrencyPackages] Error al inicializar moneda:', err);
                setCurrency('CLP'); // Fallback a CLP
                setIsDetectingCurrency(false);
            }
        };

        initializeCurrency();
    }, []);

    useEffect(() => {
        if (!isDetectingCurrency) {
            // Cargar paquetes desde la configuración con el precio correcto según la moneda
            const dynamicPackages: DynamicCoinPackage[] = paykuConfig.packages.map(pkg => ({
                ...pkg,
                // Agregar el monto según la moneda seleccionada
                amount: currency === 'USD' ? pkg.amount_usd : pkg.amount_clp,
                currency: currency,
                // Calcular CVs basado en vcoins (1 vcoin = 1 CV)
                cvs: pkg.vcoins,
                // Compatibilidad con código legacy
                coins: pkg.vcoins,
                price: currency === 'USD' ? pkg.amount_usd : pkg.amount_clp,
                // Agregar discount si no existe (0 por defecto)
                discount: 0,
                popularidad: pkg.popular ? 'alta' : 'media'
            }));

            setPackages(dynamicPackages);
        }
    }, [currency, isDetectingCurrency]);

    return {
        currency,
        packages,
        isLoading: isDetectingCurrency
    };
}
